import {TimeZone} from "@lib/talentlms/talentlms-utils";

export const currentYear = () => new Date().getFullYear()

const addMilliseconds = (date: Date, milliSeconds: number) => (
    new Date(date.getTime() + milliSeconds)
)

export const addSeconds = (date: Date, seconds: number) => (
    addMilliseconds(date, 1000 * seconds)
)

export const addMinutes = (date: Date, minutes: number) => (
    addSeconds(date, minutes * 60)
)

export const compareDates = (d1: Date, d2: Date) => (
    d1.getTime() - d2.getTime()
)

export const monthDiff = (dateFrom: Date, dateTo: Date): number => {
    return dateTo.getMonth() - dateFrom.getMonth() +
        (12 * (dateTo.getFullYear() - dateFrom.getFullYear()))
}

export const newDate = (year: number, month:number, day:number, hour:number, minute:number, second:number, timeZone?: TimeZone): Date => {
    let date = new Date(Date.UTC(year, month, day, hour, minute, second))

    let offset = 0
    if(timeZone){
        let utcDate = new Date(date.toLocaleString('en-US', { timeZone: "UTC" }))
        let tzDate = new Date(date.toLocaleString('en-US', { timeZone: timeZone }))
        offset = utcDate.getTime() - tzDate.getTime();
    }

    date.setTime( date.getTime() + offset )

    return date
}